// src/modules/common/components/Typography/Span/span.jsx
import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import withEmphasis from "../withEmphasis";

class Span extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
  };

  static defaultProps = {
    className: "",
  };

  render() {
    const { children, className, ...props } = this.props;
    return (
      <span className={className} {...props}>
        {children}
      </span>
    );
  }
}

export default withEmphasis(Span);
